import { Component } from '@angular/core';

@Component({
  selector: 'app-textarea-showcase',
  templateUrl: './textarea-showcase.component.html',
  styleUrls: ['./textarea-showcase.component.scss']
})
export class TextareaShowcaseComponent {
  basicValue: string = '';
  commentValue: string = '';
  feedbackValue: string = 'This is a great product!';
  errorValue: string = '';
  requiredValue: string = '';
  readonlyValue: string = 'This textarea is readonly. You cannot edit this content.';
  limitedValue: string = '';
  descriptionValue: string = '';

  onValueChange(newValue: string, fieldName: string): void {
    console.log(`${fieldName} changed to:`, newValue);
  }
}
